/* =============================================================================
   Ella Custom JS - Customize The Style For Layout
   =============================================================================
   IMPORTANT DISCLAIMER
   Please use only JS to style the layout.
   ============================================================================= */

document.addEventListener('DOMContentLoaded', function () {
  // Ejecutar solo en páginas de producto
  if (window.location.pathname.includes('/products/')) {
    var desc = document.querySelector('.productView-desc.halo-text-format');
    if (desc) {
      // Limpia caché HTML del tema Halo y fuerza re-render del HTML
      desc.removeAttribute('data-cache-html');
      desc.innerHTML = desc.innerHTML;
    }
  }
});

